import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MySwal = withReactContent(Swal2);

const AddLawsuitList = (props) => {
  const [loading, setLoading] = useState(true);
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState(
    props.mode === "edit"
      ? props.list.name.length > 0
        ? JSON.parse(props.list.name)
        : []
      : []
  );

  const getData = () => {
    setLoading(true);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const validateQuestion = (e) => {
    if (options.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const editQuestion = async (e) => {
    setLoading(true);
    if (validateQuestion()) {
      var body = {
        options: JSON.stringify(options),
        id: props.list.id,
      };

      await fetch("https://apidevkppp.ftpeople.pl/editLawsuitList", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then((data) => {
          MySwal.fire({
            icon: "success",
            title: "Edytowano",
            text: "listę",
          }).then(async (result) => {
            props.close();
          });
        })
        .catch((error) => {});
    }
  };

  return (
    <div
      style={{ width: "60vw", height: "70vh", top: "5vh", overflowY: "scroll" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Treść <span className="requiredStar">*</span>
              </label>
              <textarea
                spellcheck="false"
                className="textAreaNote"
                type="text"
                style={{ boxSizing: "border-box" }}
                type="text"
                value={question}
                onChange={(e) => {
                  setQuestion(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="inputBox">
            <button
              className="paymentMenuButton"
              onClick={() => {
                if (question) {
                  options.push({ id: 0, value: question, bo: true });
                  setQuestion("");
                }
              }}
            >
              {"dodaj"}
            </button>
          </div>

          <div className="inputBox" style={{ display: "block" }}>
            {options.map((el, index) => (
              <div
                style={{
                  display: "flex",
                  boxSizing: "border-box",
                  width: "100%",
                  fontSize: "0.8vw",
                }}
              >
                <div style={{ width: "80%" }}>{el.value}</div>
                <div style={{ width: "20%" }}>
                  {" "}
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={""}
                    value={index}
                    fieldUID={el.id}
                    field="team"
                    onClick={(e) => {
                      setOptions(
                        options.filter(
                          (eo, index1) => index1 !== +e.currentTarget.value
                        )
                      );
                    }}
                  >
                    <FontAwesomeIcon icon={faDeleteLeft} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editQuestion}>
              {"edytuj"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AddLawsuitList;
